import { render, staticRenderFns } from "./ChangeShopPop.vue?vue&type=template&id=1d87baf4&scoped=true"
import script from "./ChangeShopPop.vue?vue&type=script&lang=js"
export * from "./ChangeShopPop.vue?vue&type=script&lang=js"
import style0 from "./ChangeShopPop.vue?vue&type=style&index=0&id=1d87baf4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d87baf4",
  null
  
)

export default component.exports